import { ScrollToTop } from 'react-simple-scroll-up';

const Dependency = () => {

  return (
    <>
      <ScrollToTop symbol={<i className="fal fa-long-arrow-up"></i>} />
    </>
  );
};

export default Dependency;